import * as React from "react";
const SvgFiRrRotateExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rotate-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M1.996 11.09a1 1 0 0 1-.995.91q-.045.001-.09-.004a1 1 0 0 1-.907-1.086C.556 4.792 5.825 0 12 0c2.966 0 5.818 1.114 8 3.06V1a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2h-4a1 1 0 1 1 0-2h3.14A10.05 10.05 0 0 0 12 2C6.85 2 2.456 5.993 1.996 11.09M13 13.5V6a1 1 0 1 0-2 0v7.5a1 1 0 1 0 2 0m-2.5 4a1.5 1.5 0 1 0 3.001-.001 1.5 1.5 0 0 0-3 .001m12.59-5.496a.993.993 0 0 0-1.086.906C21.544 18.007 17.15 22 12 22a10.05 10.05 0 0 1-7.139-3h3.14a1 1 0 1 0 0-2H4a2 2 0 0 0-2 2v4a1 1 0 1 0 2 0v-2.06A12.05 12.05 0 0 0 12 24c6.174 0 11.443-4.792 11.995-10.91a1 1 0 0 0-.906-1.086"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rotate-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRotateExclamation;
